import { Layout } from 'react-admin';
import { CustomMenu } from './menu';
import MyAppBar from './myAppBar';

export const CustomLayout = (props) => <Layout {...props} menu={CustomMenu} appBar={MyAppBar} />;